<div style="padding: 10px">
    <div style="display: flex; justify-content: space-between; align-items: center">
        <h4>Property Inclusions</h4>
        <button mat-button
                (click)="createTempInclusion()"
                style="width: 273px;height: 52px;border: 1px solid #DEDEDE;border-radius: 8px;background-color: #161616;color: #DEDEDE;">Create an inclusion
        </button>
    </div>
    <mat-accordion class="inclusions-property">
        <mat-expansion-panel *ngFor="let item of items.data; let i = index" [hideToggle]="!item.saved">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class="panel-header">
                        <div  class="panel-header-title">Inclusions {{i + 1}}</div>
                        <div class="panel-header-item">
                            <!-- <div>English name</div> -->
                            <input [(ngModel)]="item.en" placeholder="English name*" (click)="$event.stopPropagation();" [ngClass]="{'invalid': !item.en && item.submitted}">
                        </div>

                        <div class="panel-header-item">
                            <!-- <div>中文名称</div> -->
                            <input [(ngModel)]="item.zh" placeholder="Simplified Chinese name*" style="margin-left: 0"
                               (click)="$event.stopPropagation();"
                               [ngClass]="{'invalid': !item.zh && item.submitted}">
                        </div>
                       
                        
                        <button mat-button (click)="$event.stopPropagation(); saveInclusion(item, i)"
                                style="background: #161616; margin-left: 10px;border: 1px solid #DEDEDE; width: 163px;height: 52px;">Save</button>
                        <button mat-button
                                *ngIf="!item.saved"
                                (click)="$event.stopPropagation(); discardTempInclusion(i)"
                                style="background: #161616; margin-left: 10px;border: 1px solid #DEDEDE; width: 163px;height: 52px;">Discard
                        </button>
                        <button mat-button
                                *ngIf="item.saved"
                                (click)="$event.stopPropagation(); deleteInclusion(i)"
                                style="background: #161616; margin-left: 10px;border: 1px solid #DEDEDE; width: 163px;height: 52px;">Delete
                        </button>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngIf="item.saved" style="border-top: 1px solid #ddd;position: relative;padding-bottom: 50px;">
                <div *ngFor="let subItem of item.children; let n = index" style="margin-top: 20px;">
                    <div style="display: flex;">
                        <div style="color: #fff;" class="sub-item-title">Item {{ n + 1 }}</div>
                        <div class="sub-item">
                            <div>English Name</div>
                            <input [(ngModel)]="subItem.title.en" placeholder="Item English name*" [ngClass]="{'invalid-subitem': !subItem.title.en && subItem.submitted}">
                            <textarea [(ngModel)]="subItem.content.en" placeholder="Item English content*" [ngClass]="{'invalid-subitem': !subItem.content.en && subItem.submitted}"></textarea>
                        </div>
                        <div class="sub-item">
                            <div>中文名称</div>
                            <input [(ngModel)]="subItem.title.zh" placeholder="Item Chinese name*" [ngClass]="{'invalid-subitem': !subItem.title.zh && subItem.submitted}">
                            <textarea [(ngModel)]="subItem.content.zh" placeholder="Item Chinese content*" [ngClass]="{'invalid-subitem': !subItem.content.zh && subItem.submitted}"></textarea>
                        </div>
                    </div>
                    <div style="margin-top: 4px; display: flex; justify-content: flex-end">
                        <button mat-button (click)="saveSubItem(subItem, n)" style="margin-right: 10px; background: #21a037; color: #fff">Save Item</button>
                        <button mat-button *ngIf="!subItem.saved" (click)="discardSubItem(item, subItem, n)" style="background: #f44336; color: #fff">Discard Item</button>
                        <button mat-button *ngIf="subItem.saved" (click)="deleteSubItem(item, subItem, n)" style="background: #f44336; color: #fff">Delete Item</button>
                    </div>
                </div>
                <button mat-button (click)="addSubItem(item)" style="color: #fff;border: 1px solid #fff; position: absolute;bottom: 0; border: 1px solid #fff;left: calc(100% - 960px);">Add Item</button>
                <!--                <div class="row">-->
                <!--                    <div class="title">Carpet</div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                    <div class="title">Flooring</div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                    <div class="title">Ceiling Height</div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                    <div class="title">Cornices</div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                    <div class="title">Door Handle</div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                    <div class="title">Wardrobe</div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                    <div class="title">Storage</div>-->
                <!--                </div>-->
                <!--                <div class="row">-->
                <!--                    <div class="title">Blinds</div>-->
                <!--                </div>-->

            </div>
        </mat-expansion-panel>
        <!--    <mat-expansion-panel>-->
        <!--        <mat-expansion-panel-header>-->
        <!--            <mat-panel-title>-->
        <!--                <div class="panel-header">-->
        <!--                    Interior Detailing-->
        <!--                </div>-->
        <!--            </mat-panel-title>-->
        <!--        </mat-expansion-panel-header>-->
        <!--    </mat-expansion-panel>-->
        <!--    <mat-expansion-panel>-->
        <!--        <mat-expansion-panel-header>-->
        <!--            <mat-panel-title>-->
        <!--                <div class="panel-header">-->
        <!--                    Ensuite and Bathroom-->
        <!--                </div>-->
        <!--            </mat-panel-title>-->
        <!--        </mat-expansion-panel-header>-->
        <!--    </mat-expansion-panel>-->
        <!--    <mat-expansion-panel>-->
        <!--        <mat-expansion-panel-header>-->
        <!--            <mat-panel-title>-->
        <!--                <div class="panel-header">-->
        <!--                    Heating and cooling-->
        <!--                </div>-->
        <!--            </mat-panel-title>-->
        <!--        </mat-expansion-panel-header>-->
        <!--    </mat-expansion-panel>-->
        <!--    <mat-expansion-panel>-->
        <!--        <mat-expansion-panel-header>-->
        <!--            <mat-panel-title>-->
        <!--                <div class="panel-header">-->
        <!--                    Landscaping and fencing-->
        <!--                </div>-->
        <!--            </mat-panel-title>-->
        <!--        </mat-expansion-panel-header>-->
        <!--    </mat-expansion-panel>-->
        <!--    <mat-expansion-panel>-->
        <!--        <mat-expansion-panel-header>-->
        <!--            <mat-panel-title>-->
        <!--                <div class="panel-header">-->
        <!--                    External Features-->
        <!--                </div>-->
        <!--            </mat-panel-title>-->
        <!--        </mat-expansion-panel-header>-->
        <!--    </mat-expansion-panel>-->

    </mat-accordion>

</div>
